function setPathToRedirect(productionPath: string | undefined, path: string) {
  const activeEnvironment = process.env.REACT_APP_ENV;
  return activeEnvironment === "production" ? productionPath || path : path;
}

export default setPathToRedirect;
